<script lang="ts">
import type { SimpleIcon } from "simple-icons";

let {
  icon,
  title,
  class: className,
}: {
  icon: SimpleIcon;
  title?: string;
  class?: string;
} = $props();
</script>

<svg
  class={className}
  viewBox="0 0 24 24"
  fill="currentColor"
  role={title ? "img" : undefined}
  aria-hidden={title ? undefined : "true"}
  aria-label={title}
>
  <path d={icon.path} />
</svg>
